module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABZ0lEQVQ4T7WUsUvDQBTGv3fBjsW2o7Xg6qSz4iBdWhcFXR3dYlARNy1OKkIT3fwT3FRaHZou6uygu2CzJgU3K9xJImljmsRLoZnCve/97nt37x4h5jNazosb0sr5+ShJUpzchNq1yOQL3WMBsQWBnFYukNGyxS908O/DI+OELoGuHDt36EEvTOdECHGQmBSwm7QpEZ16UMO0HdchYxOL6nL22VtLWf5l+3OB8+8neI49wKDUuDOWWfc544fKuJHR/HEqkyCjGX/5bqvIOKnUOxUo9Hq/XbSC+pEvqqp3zgCxD4Gb5k5pNRV0tvaWmZnMHjGFmXdqse0m94FAjxOtPWjTzVTQat2aA3H3/X8BbB0QS55DoEeKstFQp27DRyVV/or+cS6APQAcAEsCBh/Rv7cfAMc69B1LOfXFFd3aZJy/N3ZLj0ndkQoq02bD5UdMKVmQrxuaUuF5mhYY1PfnaXjyjwQNTP4fLK/+NKR/WkYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reserve.png
// module id = HU6e
// module chunks = 1